import { createSelector } from 'reselect';

import { type RootState } from '../types';

export const playerHistorySelector = (state: RootState) => state.history ?? {};

export const playerHistoryPayoutsSelector = createSelector(
  playerHistorySelector,
  (playerHistory) => playerHistory.payouts
);
